import { z } from "zod";

const envSchema = z.object({
  VITE_API_BASE_URL: z.url().default("http://localhost:8787"),
  /** stub: Worker 未接続でフィクスチャ表示（UI確認用）。live: SDK 経由で実 API に接続。 */
  VITE_API_MODE: z.enum(["live", "stub"]).default("live")
});

export const env = envSchema.parse(import.meta.env);
